import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { useHistory } from "react-router-dom";

export const CreditosFacturasPendientesScreen = () => {
    const history = useHistory();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [data, setData] = useState([]);
    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get("VentasFacturacionPendiente/Obtener_Facturacion_Pendiente")
            .then((result) => {
                setData(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION DE EQUIPOS", JSON.stringify(error), "error");
            });
    }, []);
    const onFacturar = (folio, cliente) => {
        history.push("/Ventas/FacturasEquipo", {
            folio,
            cliente,
        });
    };
    return (
        <PlantillaScreen
            titulo={`LISTADO DE CREDITOS PENDIENTES A FACTURAR`}
            className={"listado-equiposfacturar-screen"}
            className_main={1}
        >
            <div className="container-listado-creditos-facturar">
                <LoaderScreen loader={loader} />
                <div className="container-listado-creditos-facturar-table scroll-4">
                    {data === undefined || data === null || data.length === 0 ? (
                        <div></div>
                    ) : (
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>FECHA</th>
                                    <th>CLIENTE</th>
                                    <th>VENDEDOR</th>
                                    <th>FINANCIERA</th>
                                    <th>ESTADO</th>
                                    <th className="ta-rigth">IMPORTE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((fac) => (
                                    <tr onClick={() => onFacturar(fac.folio, fac.razon_social)}>
                                        <td>{fac.fecha}</td>
                                        <td>{fac.razon_social}</td>
                                        <td>{fac.vendedor}</td>
                                        <td className="ta-center">{fac.financiera}</td>
                                        <td>{fac.estado}</td>
                                        <td>{FormatMoney(fac.importe)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </PlantillaScreen>
    );
};
